import { render, staticRenderFns } from "./title-content-wrapper.vue?vue&type=template&id=2c24914c&scoped=true&"
import script from "./title-content-wrapper.vue?vue&type=script&lang=ts&"
export * from "./title-content-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./title-content-wrapper.vue?vue&type=style&index=0&id=2c24914c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c24914c",
  null
  
)

export default component.exports